module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/a314b6745357bba80e03ea7e9856693e.svg";